export const setUserLoggedIn = (payload) => {
  return {
    type: "SET USER LOGGED IN",
    payload,
  };
};

export const setUser = (payload) => {
  return {
    type: "SET USER",
    payload,
  };
};

export const setProducts = (payload) => {
  return {
    type: "SET PRODUCTS",
    payload,
  };
};

export const setFilteredProducts = (payload) => {
  return { type: "FILTER PRODUCTS", payload };
};

export const addToCart = (payload) => {
  return { type: "ADD_TO_CART", payload };
};

export const removeFromCart = (payload) => {
  return { type: "REMOVE_FROM_CART", payload };
};

export const clearCart = (payload = null) => {
  return { type: "CLEAR_CART", payload };
};

export const setCart = (payload) => {
  return { type: "SET_CART", payload };
};
